import { AllRoutes } from 'common/routes';
import { Route, Routes } from 'react-router-dom';

export const Routing = () => {
    return (
        <Routes>
            {AllRoutes.map((route) => (
                <Route key={route.path} path={route.path} element={route.element} />
            ))}
        </Routes>
    );
};
